import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogConfig } from 'src/app/core/components/dialog/dialog-config';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';
import { Company, CompanyLight } from 'src/app/lem/models/companies/company';
import { CompaniesDepartment, CompanyDepartmentType } from 'src/app/lem/models/departments/departments';
import { DepartmentsService } from '../../service/departments.service';
import { Role } from 'src/app/lem/models/common/role';

@Component({
  selector: 'app-modal-role',
  templateUrl: './modal-role.component.html',
  styleUrls: ['./modal-role.component.css']
})
export class ModalRoleComponent implements OnInit {

  form : FormGroup;
  role : Role;
  roleSelected : Role;
  isEnabled: boolean = false
  errors : boolean = false;
  formEdit ;

  constructor(
    private formBuilder : FormBuilder,
    private modalRef : DialogRef,
    private departmentsService : DepartmentsService,
    private dialogConfig : DialogConfig,
    private dialogRef : DialogRef
    ) { }

  ngOnInit() {
    this.roleSelected = this.dialogConfig.data.role;
    this.preselectForm()
    this.form = this.formBuilder.group({
      name : [this.role.name, [Validators.required,Validators.maxLength(50)]],
      description : [this.role.description,[Validators.required,Validators.maxLength(255)]]
    })
  }

  formReset(){
    if (this.roleSelected) {
      this.preselectForm()
      this.form = this.formBuilder.group({
        name : [this.role.name, [Validators.required,Validators.maxLength(50)]],
        description : [this.role.description,[Validators.required,Validators.maxLength(255)]]
      })
    } else {
      this.form.reset();
    }
  }

  onSave(){
    let requestRole = {name:null,description:null};
    requestRole.name = this.role.name;
    requestRole.description = this.role.description;
    this.dialogRef.close({data: requestRole, id:this.role.id,  save:true});
  }

  private preselectForm() {
    this.role = { id: '', name: '', description: '' }
    if (this.roleSelected) {
      this.role.id = this.roleSelected.id;
      this.role.name = this.roleSelected.name;
      this.role.description = this.roleSelected.description;
    }
  }

  errorCheck() {
    this.errors = !this.form.valid;
  }

}
